import React, { createContext, useState, useContext, ReactNode, useCallback } from 'react';

interface ActionSnackbarContextProps {
  snackbarMessage: string;
  isSnackbarVisible: boolean;
  showSnackbar: (message: string) => void;
  hideSnackbar: () => void;
}

const ActionSnackbarContext = createContext<ActionSnackbarContextProps | undefined>(undefined);

export const ActionSnackbarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [isSnackbarVisible, setIsSnackbarVisible] = useState<boolean>(false);

  const showSnackbar = useCallback((message: string) => {
    setSnackbarMessage(message);
    setIsSnackbarVisible(true);
  }, []);

  const hideSnackbar = useCallback(() => {
    setIsSnackbarVisible(false);
    // Optionally clear the message after hiding animation might complete
    // setTimeout(() => setSnackbarMessage(''), 300); // Adjust timing if needed
  }, []);

  return (
    <ActionSnackbarContext.Provider value={{ snackbarMessage, isSnackbarVisible, showSnackbar, hideSnackbar }}>
      {children}
    </ActionSnackbarContext.Provider>
  );
};

export const useActionSnackbar = (): ActionSnackbarContextProps => {
  const context = useContext(ActionSnackbarContext);
  if (context === undefined) {
    throw new Error('useActionSnackbar must be used within an ActionSnackbarProvider');
  }
  return context;
};
